/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_AvailableInputs */

const en_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Available for Projects`)
};

const ar_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● متاح للمشاريع`)
};

const bn_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● নতুন প্রজেক্ট নিচ্ছি`)
};

const de_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Verfügbar für Projekte`)
};

const es_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Disponible para Proyectos`)
};

const fr_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Disponible pour les projets`)
};

const pt_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Disponível para projetos`)
};

const zh_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● 可用于项目`)
};

const tr_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Projeler için Kullanılabilir`)
};

const ru_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Доступно для проектов.`)
};

const pl_resume_available = /** @type {(inputs: Resume_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● Dostępne dla projektów`)
};

/**
* | output |
* | --- |
* | "● Available for Projects" |
*
* @param {Resume_AvailableInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_available = /** @type {((inputs?: Resume_AvailableInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_AvailableInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_available(inputs)
	if (locale === "bn") return bn_resume_available(inputs)
	if (locale === "de") return de_resume_available(inputs)
	if (locale === "es") return es_resume_available(inputs)
	if (locale === "fr") return fr_resume_available(inputs)
	if (locale === "pt") return pt_resume_available(inputs)
	if (locale === "zh") return zh_resume_available(inputs)
	if (locale === "tr") return tr_resume_available(inputs)
	if (locale === "ru") return ru_resume_available(inputs)
	if (locale === "pl") return pl_resume_available(inputs)
	return en_resume_available(inputs)
});